import React__default, { Fragment } from 'react';
import { Content, Footer, Form, Header, SecondaryNav, SidePanel } from './components.js';
import { validComponentNames, validComponents } from './constants.js';
import { OuterContainer, Container, OverflowWrapper, ContentWrapper, FormWrapper } from './styles.js';
import { isNamedComponent } from './utils.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Component = ({
  children
}) => {
  const validChildrenMap = {};
  React__default.Children.forEach(children, child => {
    const validName = validComponentNames.find(name => {
      return isNamedComponent(child, validComponents[name]);
    });
    if (validName) {
      validChildrenMap[validName] = child;
    } else if (child) {
      console.group('PageLayout error');
      console.error('Invalid child:', child);
      console.error(`Only ${Object.keys(validComponents).map(name => validComponents[name]).join(', ')} are allowed. Other children are ignored.`);
      console.groupEnd();
    }
  });
  const {
    Header,
    Form,
    Content,
    SidePanel,
    Footer,
    SecondaryNav
  } = validChildrenMap;
  return jsxs(OuterContainer, {
    children: [!SecondaryNav && jsx(Fragment, {
      children: Header
    }), jsxs(Container, {
      children: [SecondaryNav, Content || Form ? jsxs(OverflowWrapper, {
        children: [SecondaryNav && jsx(Fragment, {
          children: Header
        }), !Form && Content && jsxs(ContentWrapper, {
          children: [Content, SidePanel]
        }), Form && jsx(FormWrapper, {
          hasSecondaryNav: Boolean(SecondaryNav),
          children: Form
        })]
      }) : null]
    }), Footer]
  });
};
const PageLayout = Object.assign(Component, {
  Content,
  Footer,
  Form,
  Header,
  SecondaryNav,
  SidePanel
});

export { PageLayout };
